import { createRouter, createWebHistory } from 'vue-router'
import AdminLayout from '@/layouts/AdminLayout.vue'
import DashboardView from '@/views/DashboardView.vue'
import HomeManageView from '@/views/cms/HomeManageView.vue'
import HomeSectionsManageView from '@/views/content/HomeSectionsManageView.vue'
import AboutTabsManageView from '@/views/content/AboutTabsManageView.vue'
import MeetingTabsManageView from '@/views/content/MeetingTabsManageView.vue'
import AwardManageView from '@/views/content/AwardManageView.vue'
import ActivityListManageView from '@/views/content/ActivityListManageView.vue'
import ActivityRegistrationsManageView from '@/views/content/ActivityRegistrationsManageView.vue'
import ActivitySeatingManageView from '@/views/content/ActivitySeatingManageView.vue'
import ActivityEditView from '@/views/content/ActivityEditView.vue'
import FormSubmissionsView from '@/views/form/FormSubmissionsView.vue'
import FormManageView from '@/views/form/FormManageView.vue'
import SupplyReviewView from '@/views/supply/SupplyReviewView.vue'
import SupplyIntentManageView from '@/views/supply/SupplyIntentManageView.vue'
import DictManageView from '@/views/system/DictManageView.vue'
import OperationLogView from '@/views/system/OperationLogView.vue'
import ArticleManageMergedView from '@/views/content/ArticleManageMergedView.vue'
import MemberManageView from '@/views/member/MemberManageView.vue'
import ServiceFormManageView from '@/views/member/ServiceFormManageView.vue'
import MemberMapProfileManageView from '@/views/member/MemberMapProfileManageView.vue'
import MemberEngagementManageView from '@/views/member/MemberEngagementManageView.vue'
import NetworkConnectionManageView from '@/views/network/NetworkConnectionManageView.vue'
import CooperationManageView from '@/views/cooperation/CooperationManageView.vue'
import TemplateManageView from '@/views/member/TemplateManageView.vue'
import PermissionManageView from '@/views/system/PermissionManageView.vue'
import ChangePasswordView from '@/views/system/ChangePasswordView.vue'
import LoginView from '@/views/LoginView.vue'
import { getAdminMe, getAdminToken, setAdminToken } from '@/api'

const routes = [
  {
    path: '/login',
    component: LoginView,
    meta: { title: '后台登录', public: true },
  },
  {
    path: '/lottery-screen',
    name: 'lottery-screen',
    component: () => import('@/views/public/LotteryScreenView.vue'),
    meta: { title: '抽奖大屏', public: true },
  },
  {
    path: '/',
    component: AdminLayout,
    children: [
      { path: '', redirect: '/dashboard' },
      { path: 'dashboard', name: 'dashboard', component: DashboardView, meta: { title: '工作台' } },
      {
        path: 'cms/home',
        name: 'cms-home',
        component: HomeManageView,
        redirect: '/content/articles-v2',
        children: [
          { path: 'banner', redirect: '/content/articles-v2' },
          { path: 'tile', redirect: '/content/articles-v2' },
          { path: 'about', name: 'cms-home-about', component: AboutTabsManageView, meta: { title: '关于我们' } },
          { path: 'meeting', name: 'cms-home-meeting', component: MeetingTabsManageView, meta: { title: '专业会议' } },
          { path: 'join', redirect: '/member/join-form' },
          { path: 'award', name: 'cms-home-award', component: AwardManageView, meta: { title: '表彰公示' } },
          {
            path: 'albums',
            name: 'cms-home-albums',
            component: HomeSectionsManageView,
            props: { mode: 'album' },
            meta: { title: '相册' }
          },
          {
            path: 'albums/:id',
            name: 'cms-home-album-detail',
            component: () => import('@/views/content/AlbumDetailManageView.vue'),
            meta: { title: '相册详情' },
          }
        ]
      },
      { path: 'cms/banner', redirect: '/content/articles-v2' },
      { path: 'cms/tile', redirect: '/content/articles-v2' },
      { path: 'cms/home/tile', redirect: '/content/articles-v2' },
      { path: 'content/about', redirect: '/cms/home/about' },
      { path: 'content/meeting', redirect: '/cms/home/meeting' },
      { path: 'content/activities', name: 'content-activities', component: ActivityListManageView, meta: { title: '活动管理' } },
      {
        path: 'content/satisfaction-forms',
        name: 'content-satisfaction-forms',
        component: FormManageView,
        props: { formCategory: 'SATISFACTION', showExportConfig: false },
        meta: { title: '问卷管理' },
      },
      {
        path: 'content/satisfaction/responses',
        redirect: (to) => {
          const id = to.query && to.query.activityId
          if (id) return `/content/activity-registrations/${id}/satisfaction-responses`
          return '/content/activities'
        },
      },
      {
        path: 'content/activity-registrations/:activityId',
        name: 'content-activity-registrations',
        component: ActivityRegistrationsManageView,
        meta: { title: '活动报名名单' },
      },
      {
        path: 'content/activity-view-logs/:activityId',
        name: 'content-activity-view-logs',
        component: () => import('@/views/content/ActivityViewLogsManageView.vue'),
        meta: { title: '活动浏览记录' },
      },
      {
        path: 'content/activity-registrations/:activityId/seating',
        name: 'content-activity-seating',
        component: ActivitySeatingManageView,
        meta: { title: '活动排座' },
      },
      {
        path: 'content/activity-registrations/:activityId/lottery',
        name: 'content-activity-lottery',
        component: () => import('@/views/content/ActivityLotteryManageView.vue'),
        meta: { title: '现场抽奖' },
      },
      {
        path: 'content/activity-registrations/:activityId/satisfaction-responses',
        name: 'content-activity-satisfaction-responses',
        component: () => import('@/views/content/SatisfactionResponsesView.vue'),
        meta: { title: '问卷答卷' },
      },
      {
        path: 'content/activity-registrations/:activityId/signup-edit/:submissionId',
        name: 'content-activity-signup-edit',
        component: () => import('@/views/activity/ActivitySignupEditView.vue'),
        meta: { title: '编辑活动报名填报' },
      },
      {
        path: 'content/activity-fee-orders',
        name: 'content-activity-fee-orders',
        component: () => import('@/views/content/ActivityFeeOrdersManageView.vue'),
        meta: { title: '活动费凭证审核' },
      },
      { path: 'content/activities/edit/:id', name: 'content-activity-edit', component: ActivityEditView, meta: { title: '活动编辑' } },
      { path: 'content/articles-v2', name: 'content-articles-v2', component: ArticleManageMergedView, meta: { title: '资讯管理' } },
      { path: 'content/articles', redirect: '/content/articles-v2' },
      { path: 'form/submissions', name: 'form-submissions', component: FormSubmissionsView, meta: { title: '入会申请记录' } },
      { path: 'supply/review', name: 'supply-review', component: SupplyReviewView, meta: { title: '供需审核' } },
      { path: 'supply/intents', name: 'supply-intents', component: SupplyIntentManageView, meta: { title: '合作撮合' } },
      { path: 'member/manage', name: 'member-manage', component: MemberManageView, meta: { title: '会员管理' } },
      {
        path: 'member/personnel/:id',
        name: 'member-personnel',
        component: () => import('@/views/member/MemberPersonnelManageView.vue'),
        meta: { title: '成员信息' },
      },
      { path: 'member/map-profiles', name: 'member-map-profiles', component: MemberMapProfileManageView, meta: { title: '全部用户' } },
      { path: 'member/engagement', name: 'member-engagement', component: MemberEngagementManageView, meta: { title: '会员活跃度' } },
      { path: 'member/network-orders', name: 'member-network-orders', component: NetworkConnectionManageView, meta: { title: '人脉订单' } },
      { path: 'member/cooperation', name: 'member-cooperation', component: CooperationManageView, meta: { title: '跨组织合作' } },
      { path: 'member/confirm-templates', redirect: '/member/templates?tab=confirm' },
      { path: 'member/fee-templates', redirect: '/member/templates?tab=fee' },
      { path: 'member/fee-prices', redirect: '/member/templates?tab=price' },
      { path: 'member/templates', name: 'member-templates', component: TemplateManageView, meta: { title: '模板管理' } },
      {
        path: 'member/join-form',
        name: 'member-join-form',
        component: FormManageView,
        props: { fixedFormCode: 'membership_apply' },
        meta: { title: '入会表单管理' },
      },
      {
        path: 'member/service-forms',
        name: 'member-service-forms',
        component: ServiceFormManageView,
        meta: { title: '服务登记管理' },
      },
      {
        path: 'member/service-form-config/:code',
        name: 'member-service-form-config',
        component: FormManageView,
        props: (route) => {
          const code = String(route.params.code || '').trim()
          const names = {
            visit_register: ['来访登记', '接待来访客户登记'],
            walk_register: ['走访登记', '外出走访客户登记'],
            member_service: ['会员服务', '会员上门服务记录'],
          }
          const qName = String((route.query && route.query.name) || '').trim()
          const qDesc = String((route.query && route.query.description) || '').trim()
          const pair = names[code] || [code, '']
          return {
            fixedFormCode: code,
            fixedFormName: qName || pair[0],
            fixedFormDescription: qDesc || pair[1],
            showExportConfig: false,
          }
        },
        meta: { title: '服务表单配置' },
      },
      { path: 'operation/messages', redirect: '/operation/messages/records' },
      {
        path: 'operation/messages/records',
        name: 'operation-message-records',
        component: () => import('@/views/operation/message/MessageSendRecordView.vue'),
        meta: { title: '消息发送记录' },
      },
      {
        path: 'operation/messages/center',
        name: 'operation-message-center',
        component: () => import('@/views/system/MessageCenterView.vue'),
        meta: { title: '消息中心' },
      },
      {
        path: 'operation/messages/passive',
        name: 'operation-message-passive',
        component: () => import('@/views/operation/message/PassiveMessageManageView.vue'),
        meta: { title: '被动消息管理' },
      },
      {
        path: 'operation/messages/create',
        name: 'operation-message-create',
        component: () => import('@/views/operation/message/MessageCreateView.vue'),
        meta: { title: '新建信息' },
      },
      {
        path: 'operation/messages/detail/:id',
        name: 'operation-message-detail',
        component: () => import('@/views/operation/message/MessageDetailView.vue'),
        meta: { title: '消息明细' },
      },
      { path: 'system/dict', name: 'system-dict', component: DictManageView, meta: { title: '字典管理' } },
      { path: 'system/mp-display-labels', redirect: { path: '/system/dict', query: { typeCode: 'MP_DISPLAY_GROUP' } } },
      { path: 'system/messages', redirect: '/operation/messages/center' },
      { path: 'system/operation-logs', name: 'system-operation-logs', component: OperationLogView, meta: { title: '操作日志' } },
      { path: 'system/permissions', name: 'system-permissions', component: PermissionManageView, meta: { title: '权限管理' } },
      { path: 'system/change-password', name: 'system-change-password', component: ChangePasswordView, meta: { title: '修改密码' } },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

let checkedMe = false
router.beforeEach(async (to) => {
  if (to.meta?.public) {
    if (to.path === '/login') checkedMe = false
    return true
  }
  const token = getAdminToken()
  if (!token) {
    checkedMe = false
    return '/login'
  }
  if (!checkedMe) {
    try {
      const me = await getAdminMe()
      localStorage.setItem('admin.profile', JSON.stringify(me || {}))
      checkedMe = true
    } catch (e) {
      checkedMe = false
      setAdminToken('')
      localStorage.removeItem('admin.profile')
      return '/login'
    }
  }
  return true
})

export default router

